import t from "./type";
import { AuthAPI } from "../../../Auth/requestHandler";
import apiType from "../APIResponseActions/type";

export const fetchCloudVpcDevices =
  (propertyId, needLog = false) =>
  async (dispatch) => {
    try {
      // Fixed: Using Template Literals (prefer-template)
      // Fixed: camelCase for propertyId and needLog
      const url = `cloudvpc/list?page_size=10&page=1&search=&order_by=created_at&sorting=ASC&property_id=${propertyId}${needLog ? "&need_log=true" : ""}`;

      const result = await AuthAPI("domain", url, "GET");
      await dispatch({ type: t.FETCH_CLOUD_VPC_DEVICES, payload: result.rows });
      await dispatch({
        type: apiType.API_RESPONSE_SUCCESS,
        payload: result.msg,
      });
    } catch (error) {
      await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: error });
    }
  };

export const addCloudVpc = (data) => async (dispatch) => {
  try {
    // Required fields check — early return to reduce nesting
    if (!data.mac_id || !data.public_ip || !data.approach_ip || !data.away_ip || !data.key) {
      await dispatch({
        type: apiType.API_RESPONSE_FAILURE,
        payload: "Required network fields (MAC, IP, Key) cannot be empty",
      });
      return;
    }

    const vpcData = {
      server: data.server,
      property_id: data.property_id,
      lot_id: data.lot_id,
      public_ip: data.public_ip,
      public_ip_port: data.public_ip_port,
      camera_user: data.camera_user,
      camera_pass: data.camera_pass,
      approach_ip: data.approach_ip,
      away_ip: data.away_ip,
      default_direction: data.default_direction,
      mac_id: data.mac_id,
      key: data.key,
      active: data.active ? 1 : 0,
      permit_sync: data.permit_sync ? 1 : 0,
      vend: data.vend ? 1 : 0,
      vend_relay: data.vend_relay ? 1 : 0,
      vend_whitelist: data.vend_whitelist ? 1 : 0,
      vend_ip: data.vend_ip || null,
      vend_port: data.vend_port || null,
    };
    // eslint-disable-next-line no-console
    console.log(vpcData);
    // Server route expects POST to cloudvpc/add
    const response = await AuthAPI("domain", "cloudvpc/add", "POST", vpcData);

    if (!response?.success) {
      await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: response.message });
      return;
    }

    if (response.action === "add") {
      await dispatch({ type: t.ADD_CLOUD_VPC, payload: response.data });
      await dispatch({ type: apiType.API_RESPONSE_SUCCESS, payload: response.msg });
    }
  } catch (error) {
    await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: error });
  }
};

export const editCloudVpc = (data) => async (dispatch) => {
  try {
    // Fixed: Template Literal for URL concatenation
    const url = `cloudvpc/update/${data.id}`;
    const response = await AuthAPI("domain", url, "PATCH", data);
    await dispatch({ type: t.EDIT_CLOUD_VPC, payload: response.data });
    await dispatch({
      type: apiType.API_RESPONSE_SUCCESS,
      payload: response.message,
    });
  } catch (error) {
    await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: error });
  }
};

export const deleteCloudVpc =
  ({ id, propertyId }) =>
  async (dispatch) => {
    try {
      // Fixed: Object Shorthand (id instead of id: id)
      const vpcIdData = {
        id,
        property_id: propertyId,
      };
      const response = await AuthAPI("domain", `cloudvpc/delete/${id}`, "DELETE", vpcIdData);
      if (response.success === 1) {
        await dispatch({ type: t.DELETE_CLOUD_VPC, payload: vpcIdData });
        await dispatch({
          type: apiType.API_RESPONSE_SUCCESS,
          payload: response.message,
        });
      }
    } catch (error) {
      await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: error });
    }
  };
